import { MenuOptions } from './TopBar.types'

export const ENABLED_MENU_OPTIONS: MenuOptions[] = [
  MenuOptions.ABOUT,
  MenuOptions.HOW_IT_WORKS,
  MenuOptions.CREATORS,
  MenuOptions.BRAND,
]
